<template>
  <div>
    <div class="h-full pointer Profile-pic" @click="PickupFile">
      <img v-if="File" :src="File.url" class="object-cover h-full w-full" />
      <img v-if="img" :src="img" class="object-cover h-full w-full" />
      <img
        v-show="!img || !File"
        class="h-full pic-style"
        src="@/assets/images/logo/lecturer_pic.svg"
      />
    </div>
    <input
      type="file"
      style="display: none"
      ref="fileInput"
      @change="UploadFile($event)"
    />
  </div>
</template>

<script>
import normAxios from "axios";

export default {
  methods: {
    PickupFile() {
      this.$refs.fileInput.click();
    },
    async UploadFile(e) {
      console.log(e.target.files[0]);
      let fd = new FormData();
      fd.append("file", e.target.files[0]);
      fd.append("folder_id", 1);
      try {
        let res = await normAxios.post(
          "https://api.fastation.co.th/file/api/file/create",
          fd
        );
        // console.log("response",res.data.data);
        if (res.status == 200) {
          this.File = res.data.data.uploadFileAtLevel;
          this.$emit("Get-imgUrl", this.File.url);
        } else {
          alert(res.data.message);
        }
      } catch (error) {
        alert(error.response.data.message.toString());
      }

      // this.$emit("imgUrl")
    }
  },
  data() {
    return {
      File: null
    };
  },
  props: {
    img: String
  }
};
</script>

<style lang="scss" scoped>
.Profile-pic {
  border-radius: 50%;
  border-style: none;
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
  overflow: hidden;
}
.pic-style {
  display: inline;
  margin: 0 auto;
  height: 100%;
  width: auto;
  object-fit: cover;
}
</style>
